import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { jump } from 'utils/Tweens'

// eslint-disable-next-line no-unused-vars
const setting = {
  showZero: true,
  bandChangeOffset: 1,
  delayEndAnimation: 2,
  ease: gsap.parseEase('Quad.easeIn'),
  linearTiming: true,
  bands: [
    { // Big
      amount: 5,
      type: 'big',
      animation: {
        in: 'big-in',
        loop: 'big-loop',
        out: 'big-out',
        transform: 'big-to-ultra',
      },
      minDuration: 5,
      maxDuration: 7,
      startOffset: 0.46,
      titleIndex: 0,
      music: 'sfx_bigwin_loop_big',

    },
    { // ultra
      amount: 10,
      animation: {
        in: 'ultra-in',
        loop: 'ultra-loop',
        out: 'ultra-out',
        transform: 'ultra-to-mega',
      },
      type: 'ultra',
      minDuration: 8,
      maxDuration: 12,
      startOffset: 0.46,
      titleIndex: 1,
      music: 'sfx_bigwin_loop_mega',

    },
    { //  Mega
      amount: 50,
      type: 'mega',
      animation: {
        loop: 'mega-loop',
        out: 'mega-out',
      },
      maxAmount: 20000,
      minDuration: 14,
      maxDuration: 24,
      startOffset: 0.46,
      titleIndex: 2,
      music: 'sfx_bigwin_loop_supermega',

    },
  ],
}

export default class BigWinAnimations {
  constructor(data) {
    this._data = data

    this._bands = null

    this._ease = null

    this._countTime = 0

    this.isAnimate = false

    this._countDuration = 0

    this._win = 0

    this._bet = 0

    this._winOverBet = 0

    this._speed = 1 * gsap.globalTimeline.timeScale()

    this._currentBandIndex = 0

    this._targetBand = null

    this._targetBandIndex = 0

    this._stage = -1

    this._countTime = 0

    this._countDuration = 0

    this._nextBandTime = -1

    this._bandChangeOffset = 1

    this._linearTiming = false

    this._showZero = true

    this._hideCurrencySymbol = true

    this._bandDuration = 0

    this._roundTimeTo = 0

    this._roundTimeOffset = 0

    this._skip = false

    this._setupBigWin()

    this.createSignal()

  }

  createSignal(){
    signal.on('WIN-ANIMATE', this._startBigWin.bind(this))

    signal.on('BUTTON:spin', () => {
      this.fastForward()
    })
    signal.on('WIN-TAP', () => {

      this.fastForward()
    })
  }
  /**
   * Set up the big win
   * @private
   */
  _startBigWin(){
    this.reset()

    signal.dispatch('COIN:IN')
    const winModel = game.models.WinModel.get()
    const win = winModel.totalWin >= winModel.linesWin ? winModel.totalWin : winModel.linesWin + winModel.totalWin
    game.bigwin.counter.visible = true
    game.bigwin.title.visible = true
    this.animate(win, winModel.bet)

  }
  /**
     * Set up the big win
     * @private
     */
  _setupBigWin() {
    this._bands = setting.bands
    this._bandChangeOffset = typeof setting.bandChangeOffset == 'number' ? setting.bandChangeOffset : 1
    this._ease = setting.ease
    this._linearTiming = setting.linearTiming
    this._roundTimeTo = setting.roundTo
    this._roundTimeOffset = setting.roundOffset

    if (typeof setting.hideCurrencySymbol != 'undefined') {
      this._hideCurrencySymbol = setting.hideCurrencySymbol
    }
    if (typeof setting.showZero != 'undefined') {
      this._showZero = setting.showZero
    }
  }
  setBigToUpdate(){
    game.application.ticker.add(this._onUpdateCounter, this)
  }

  clearBigToUpdate(){
    game.application.ticker.remove(this._onUpdateCounter, this)
  }

  reset() {

    if (this._stage !== 0) {
      this.clearBigToUpdate()

      this.isAnimate = false
      this._stage = 0
      this._currentBandIndex = 0
      this._targetBandIndex = 0
      this._targetBand = null
      this._win = 0
      this._bet = 0
      this._winOverBet = 0
      this._speed = 1 * gsap.globalTimeline.timeScale()
      this._countTime = 0
      this._countDuration = 0
      this._nextBandTime = -1
      this._bandDuration = 0
      this._skip = false
      this._updateCounter(0)
      this._resetAnimation()
      signal.dispatch('WIN-ANIMATE:DONE')
      signal.dispatch('COIN:OUT')

    }
  }

  _resetAnimation() {
    game.bigwin.title.stop()
    game.bigwin.title.visible = false
    game.bigwin.title.setToSetupPose()
    game.bigwin.counter.visible = false
  }

  /**
     * Play the animation
     * @param {Number} win The amount that was won
     * @param {Number} bet The amount that was bet
     * @param {Number} [delay=0] The delay before playing the animation
     * @param {Number} [speed=1] The speed to play the animation
     */
  animate(win, bet, delay, speed) {
    let bands = this._bands
    let targetBandIndex = bands.length - 1
    let winAmount = win / bet

    // Find the target band
    for (let i = 0; i <= targetBandIndex; ++i) {
      if (winAmount < bands[i].amount) {
        targetBandIndex = i - 1
        break
      }
    }

    // Begin the animation
    if (targetBandIndex >= 0) {
      this.reset()

      this._stage = 1
      this._win = win
      this._bet = bet
      this._speed  = speed * gsap.globalTimeline.timeScale() || 1 * gsap.globalTimeline.timeScale()
      this._winOverBet = winAmount
      this._targetBandIndex = targetBandIndex
      let targetBand = this._targetBand = bands[targetBandIndex]

      this._beginAppear(bands[this._currentBandIndex + this._bandChangeOffset - 1], targetBand, delay, speed)
    }
    else {
      signal.dispatch('WIN-ANIMATE:DONE')
    }
  }

  _beginAppear(currentBand) {
    const animation = currentBand.animation
    signal.dispatch(`SOUND:win:${currentBand.type}`)
    game.bigwin.title.playCallBack(animation.in, false, () => {
      game.bigwin.title.playCallBack(animation.loop, true)
    })
    signal.dispatch(`PARTICLE:${currentBand.type}`)
    this._onAppearComplete()

  }

  _onAppearComplete() {
    let targetBand = this._targetBand
    let speed = this._speed

    this._startCountTicker(targetBand, this._bands[this._targetBandIndex + 1], this._winOverBet)
    this._beginCountUp(this._bands[this._currentBandIndex + this._bandChangeOffset - 1], targetBand, this._countDuration, this._bandDuration, this._win, this._bet, speed)
  }

  _beginCountUp() {

  }

  _startCountTicker(band, nextBand, winOverBet) {
    this._countDuration = this._linearTiming ? (band.minDuration + ((winOverBet - band.amount) / (nextBand != null ? nextBand.amount : band.maxAmount)) * (band.maxDuration - band.minDuration)) : band.duration

    let roundTo = this._roundTimeTo
    if (typeof roundTo == 'number' && roundTo > 0) {
      this._countDuration = (this._roundTimeOffset || 0) + roundTo * Math.ceil(this._countDuration / roundTo)
    }

    let nextBandTime = this._nextBandTime = this._calculateBandTime(this._currentBandIndex)
    this._bandDuration = nextBandTime === -1 ? 0 : nextBandTime - this._countTime
    this.setBigToUpdate()
  }
  _onUpdateCounter() {
    const ticker = game.application.ticker
    const dt = gsap.ticker.deltaRatio(ticker.FPS) / ticker.FPS
    let bands = this._bands
    let speed = this._speed
    let winOverBet = this._winOverBet
    let targetBand = this._targetBand
    let finalBandChange = false

    let time = this._countTime += (speed * dt)

    let progress = time / this._countDuration
    let ease = this._ease
    if (ease != null) {
      progress = ease(progress)
    }

    // Handle changing band
    let nextBandTime = this._nextBandTime

    if (nextBandTime !== -1 && time >= nextBandTime) {
      // Play the band change
      let changeOffset = this._bandChangeOffset - 1
      let currentBandIndex = this._currentBandIndex + changeOffset
      let nextBandIndex = (++this._currentBandIndex) + changeOffset
      let currentBand = bands[currentBandIndex]
      let nextBand = bands[nextBandIndex]
      let nextBandTime = this._nextBandTime = this._calculateBandTime(this._currentBandIndex)
      let bandDuration = this._bandDuration = nextBandTime === -1 ? 0 : nextBandTime - this._countTime
      finalBandChange = targetBand === nextBand && targetBand.amount === winOverBet
      this._changeBand(currentBand, nextBand, bandDuration, finalBandChange, speed)
    }

    // Update the counter
    let win = this._win

    if (progress < 1) {
      this._updateCounter(progress * win)
    }
    else {
      // Complete the count up
      this._stage = 2
      this.clearBigToUpdate()
      this._updateCounter(win)

      // Play the complete animation
      let bet = this._bet
      this._countUpComplete(targetBand, finalBandChange, win, bet, speed)

    }

  }

  _updateCounter(win) {
    if(game.bigwin.counter){
      game.bigwin.counter.update(this._formatWin(win).split('.').join(','), false)
    }
  }

  _formatWin(win) {
    if (this._showZero || win !== 0) {

      return FormatService.currency(win, false)
    }
    else {
      return ''
    }
  }

  _changeBand(fromBand, toBand) {
    const animationFrom = fromBand.animation
    const animationTo = toBand.animation
    signal.dispatch(`SOUND:win:${toBand.type}`)
    signal.dispatch(`PARTICLE:${toBand.type}`)
    jump(game.bigwin.counter.text).then(() => {

    })
    game.bigwin.title.playCallBack(animationFrom.transform, false, () => {
      game.bigwin.title.playCallBack(animationTo.loop, true)
    })
  }

  _countUpComplete(targetBand) {
    const animation = targetBand.animation
    signal.dispatch('COIN:OUT')
    const delay = gsap.delayedCall(setting.delayEndAnimation, () => {
      game.bigwin.title.playCallBack(animation.out, false, () => {
        delay.kill()
        this.reset()
      })
    })

  }

  fastForward() {
    let stage = this._stage

    if (stage !== 0) {
      if( this._skip) {
        return
      }
      this._skip = true
      let targetBand = this._targetBand
      this._currentBandIndex = this._targetBandIndex
      let win = this._win
      let bet = this._bet
      let speed = this._speed

      switch (stage) {
        case 1:
          this.clearBigToUpdate()
          this._stage = 2
          this._fastForwardCountUp(targetBand, win, bet, speed)
          break
        case 2:
          this.clearBigToUpdate()
          this._stage = 3
          this._fastForwardCountComplete(targetBand, win, bet, speed)
          break
        case 3:
          this.clearBigToUpdate()
          this._stage = 4
          this._fastForwardHiding(targetBand, win, bet, speed)
          break
      }
      signal.dispatch('COIN:OUT')
      if (targetBand){
        switch (targetBand.type) {
          case 'big': signal.dispatch('PARTICLE:big')
            break
          case 'ultra': signal.dispatch('PARTICLE:ultra')
            break
          case 'mega': signal.dispatch('PARTICLE:mega')
            break
        }
      }
    }
  }

  /**
     * Fast forward during the count up
     * @param {Object} targetBand
     * @param {Number} win
     * @param {Number} bet
     * @param {Number} speed
     * @private
     */
  // eslint-disable-next-line no-unused-vars
  _fastForwardCountUp(targetBand, win, bet, speed) {
    game.bigwin.counter.update(this._formatWin(win).split('.').join(','))
    const animation = targetBand.animation
    game.bigwin.title.playCallBack(animation.loop, false, () => {
      game.bigwin.title.playCallBack(animation.out, false, () => {
        this.reset()
      })
    })

  }

  /**
     * Fast forward while the count up has completed
     * @param {Object} targetBand
     * @param {Number} win
     * @param {Number} bet
     * @param {Number} speed
     * @private
     */
  // eslint-disable-next-line no-unused-vars
  _fastForwardCountComplete(targetBand, win, bet, speed) {
    const animation = targetBand.animation
    game.bigwin.counter.update(this._formatWin(win).split('.').join(','), false)
    game.bigwin.title.playCallBack(animation.loop, false, () => {
      game.bigwin.title.playCallBack(animation.out, false, () => {
        this.reset()
      })
    })
  }

  _fastForwardHiding(targetBand, win) {
    if(game.bigwin.counter){
      game.bigwin.counter.update(this._formatWin(win).split('.').join(','), false)
    }
    const animation = targetBand.animation
    game.bigwin.title.playCallBack(animation.loop, false, () => {
      game.bigwin.title.playCallBack(animation.out, false, () => {
        this.reset()
      })
    })
  }

  _calculateBandTime(bandIndex) {
    let band = this._bands[bandIndex + this._bandChangeOffset]

    if (band != null) {
      return (this._getEaseRatio(band.amount / this._winOverBet) * this._countDuration) - (band.startOffset || 0)
    }
    else {
      return -1
    }
  }

  /**
     * Get the ease ratio
     * @param {Number} ratio
     * @returns {Number}
     * @private
     */
  _getEaseRatio(ratio) {
    switch (this._ease) {
      // Power 1
      case gsap.parseEase('Power1.easeIn'):
        return Math.pow(ratio, 1 / 2)
      case gsap.parseEase('Power1.easeOut'):
        return 1 - Math.pow(1 - ratio, 1 / 2)
      case gsap.parseEase('Power1.easeInOut'):
        return ratio < 0.5 ? Math.pow(ratio * 0.5, 1 / 2) : 1 - Math.pow((1 - ratio) * 0.5, 1 / 2)
        // Power 2
      case gsap.parseEase('Power2.easeIn'):
        return Math.pow(ratio, 1 / 3)
      case gsap.parseEase('Power2.easeOut'):
        return 1 - Math.pow(1 - ratio, 1 / 3)
      case gsap.parseEase('Power2.easeInOut'):
        return ratio < 0.5 ? Math.pow(ratio * 0.5, 1 / 3) : 1 - Math.pow((1 - ratio) * 0.5, 1 / 3)
        // Power 3
      case gsap.parseEase('Power3.easeIn'):
        return Math.pow(ratio, 1 / 4)
      case gsap.parseEase('Power3.easeOut'):
        return 1 - Math.pow(1 - ratio, 1 / 4)
      case gsap.parseEase('Power3.easeInOut'):
        return ratio < 0.5 ? Math.pow(ratio * 0.5, 1 / 4) : 1 - Math.pow((1 - ratio) * 0.5, 1 / 4)
        // Power 4
      case gsap.parseEase('Power4.easeIn'):
        return Math.pow(ratio, 1 / 5)
      case gsap.parseEase('Power4.easeOut'):
        return 1 - Math.pow(1 - ratio, 1 / 5)
      case gsap.parseEase('Power4.easeInOut'):
        return ratio < 0.5 ? Math.pow(ratio * 0.5, 1 / 5) : 1 - Math.pow((1 - ratio) * 0.5, 1 / 5)
        // Default
      default:
        return ratio
    }
  }

  _changeMusic() {
  }
}
